(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-recommandations"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Mobile carousel dots
  function initCarouselDots() {
    if (window.innerWidth > 749) return;
    document.querySelectorAll('[id^="bundle-reco-grid-"]').forEach(function (grid) {
      var sectionId = grid.id.replace('bundle-reco-grid-', '');
      var dotsWrap = document.getElementById('bundle-reco-dots-' + sectionId);
      var wrap = grid.closest('.bundle-reco__grid-wrap');
      if (!dotsWrap) return;
      var cards = Array.from(grid.children);

      // Manage right fade visibility
      function updateFade() {
        if (!wrap) return;
        var atEnd = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 8;
        var hasMore = grid.scrollWidth > grid.clientWidth + 8;
        wrap.classList.toggle('bundle-reco__grid-wrap--no-fade', atEnd || !hasMore);
      }
      updateFade();
      grid.addEventListener('scroll', updateFade, { passive: true });

      if (cards.length < 2) return;
      dotsWrap.innerHTML = '';
      cards.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.className = 'bundle-reco__dot' + (i === 0 ? ' bundle-reco__dot--active' : '');
        dot.setAttribute('aria-label', 'Slide ' + (i + 1));
        dot.addEventListener('click', function () {
          cards[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        });
        dotsWrap.appendChild(dot);
      });
      grid.addEventListener('scroll', function () {
        var center = grid.scrollLeft + grid.offsetWidth / 2;
        var activeIdx = 0;
        var minDist = Infinity;
        cards.forEach(function (card, i) {
          var cardCenter = card.offsetLeft + card.offsetWidth / 2;
          var dist = Math.abs(cardCenter - center);
          if (dist < minDist) { minDist = dist; activeIdx = i; }
        });
        dotsWrap.querySelectorAll('.bundle-reco__dot').forEach(function (dot, i) {
          dot.classList.toggle('bundle-reco__dot--active', i === activeIdx);
        });
      }, { passive: true });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCarouselDots);
  } else {
    initCarouselDots();
  }

  // Mobile: scroll carousel to the badge card on init
  function initBadgeScroll() {
    if (window.innerWidth > 749) return;
    document.querySelectorAll('[id^="bundle-reco-grid-"]').forEach(function (grid) {
      var badgeCard = grid.querySelector('.bundle-card--with-badge');
      if (!badgeCard) return;
      // Use requestAnimationFrame to let layout settle first
      requestAnimationFrame(function () {
        var gridLeft = grid.getBoundingClientRect().left;
        var cardLeft = badgeCard.getBoundingClientRect().left;
        var offset = cardLeft - gridLeft - (grid.offsetWidth - badgeCard.offsetWidth) / 2;
        grid.scrollLeft = offset;
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBadgeScroll);
  } else {
    initBadgeScroll();
  }

  function getSection(target) {
    return target.closest('.bundle-reco');
  }

  // Helpers
  function getText(el) { return el ? el.textContent : ''; }
  function getHTML(el) { return el ? el.innerHTML : ''; }
  function setText(popup, sel, val) { var el = popup.querySelector(sel); if (el && val) el.textContent = val; }
  function setHTML(popup, sel, val) { var el = popup.querySelector(sel); if (el != null && val != null) el.innerHTML = val; }

  // Build fan images HTML (up to 9)
  function buildFanHTML(imagesStr, urlsStr) {
    var urls = urlsStr ? urlsStr.split('|').map(function(s){ return s.trim(); }) : [];
    return imagesStr.split('|')
      .map(function (s) { return s.trim(); })
      .filter(function (s) { return s.length > 0; })
      .slice(0, 9)
      .map(function (url, i) {
        var prodUrl = urls[i] || '';
        var tag = prodUrl ? 'a' : 'div';
        var href = prodUrl ? ' href="' + prodUrl + '" target="_blank" rel="noopener"' : '';
        return '<' + tag + ' class="offre-acc__fan-img offre-acc__fan-img--' + (i + 1) + '"' + href + '>' +
          '<img src="' + url + '" alt="" loading="lazy">' +
          '</' + tag + '>';
      }).join('');
  }

  // Build original checkmark feature list
  var CHECK_SVG = '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M2.5 8.5l3.5 3.5 7-7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  function buildKitListHTML(raw) {
    var items = raw.indexOf('|') !== -1 ? raw.split('|') : raw.split('\n');
    return '<ul class="offre-acc__kit-list">' +
      items
        .map(function (s) { return s.trim(); })
        .filter(function (s) { return s.length > 0; })
        .map(function (s) {
          return '<li class="offre-acc__kit-item">' + s + '</li>';
        }).join('') +
      '</ul>';
  }

  // Build products reel HTML: image + ×1 + price (up to 9)
  function buildProductsReelHTML(imagesStr, pricesStr, urlsStr) {
    var imgs   = imagesStr.split('|').map(function(s){ return s.trim(); }).filter(Boolean).slice(0, 9);
    var prices = pricesStr ? pricesStr.split('|').map(function(s){ return s.trim(); }) : [];
    var urls   = urlsStr   ? urlsStr.split('|').map(function(s){ return s.trim(); })   : [];
    return imgs.map(function(url, i) {
      var price   = prices[i] || '';
      var prodUrl = urls[i]   || '';
      var tag     = prodUrl ? 'a' : 'div';
      var href    = prodUrl ? ' href="' + prodUrl + '" target="_blank" rel="noopener"' : '';
      return '<' + tag + ' class="offre-acc__products-reel-item"' + href + '>' +
        '<div class="offre-acc__products-reel-img"><img src="' + url + '" alt="" loading="lazy"></div>' +
        '<span class="offre-acc__products-reel-qty">×1</span>' +
        (price ? '<span class="offre-acc__products-reel-price">' + price + '</span>' : '') +
        '</' + tag + '>';
    }).join('');
  }

  // Store original popup content once (before any modifications)
  var popup = document.getElementById('offre-acc-root');
  var originals = null;
  if (popup) {
    originals = {
      badge:   getText(popup.querySelector('.offre-acc__badge')),
      title:   getText(popup.querySelector('.offre-acc__title')),
      desc:    getText(popup.querySelector('.offre-acc__desc')),
      kitHTML: getHTML(popup.querySelector('.offre-acc__kit')),
      submit:  getText(popup.querySelector('.offre-acc__submit')),
      code:    getText(popup.querySelector('[data-offre-code]'))
    };
  }

  // Open offre popup (claim button + "Voir le détail")
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bundle-open-offre]');
    if (!btn || !getSection(btn)) return;
    var popup = document.getElementById('offre-acc-root');
    if (!popup) return;

    var d = btn.dataset;
    var fromAtc = d.fromAtc === 'true';

    // Inject colors
    if (d.bcGreen)    popup.style.setProperty('--acc-green',     d.bcGreen);
    if (d.bcLight)    popup.style.setProperty('--acc-light',     d.bcLight);
    if (d.bcBorder)   popup.style.setProperty('--acc-border',    d.bcBorder);
    if (d.bcBtnBg)    popup.style.setProperty('--acc-btn-bg',    d.bcBtnBg);
    if (d.bcAccent)   popup.style.setProperty('--acc-accent',    d.bcAccent);
    if (d.bcBtnColor) popup.style.setProperty('--acc-btn-color', d.bcBtnColor);

    // Inject text content
    setText(popup, '.offre-acc__badge', d.popupBadge);
    setText(popup, '.offre-acc__title', d.popupTitle);
    setText(popup, '.offre-acc__desc',  d.popupDesc);
    setText(popup, '.offre-acc__submit', d.popupSubmit);
    setText(popup, '[data-offre-code]',  d.popupCode);
    if (d.popupTitle) setText(popup, '.offre-acc__merci', d.popupTitle + '\u00a0! Voici votre code\u00a0:');
    // Nom du bundle à droite du label formulaire
    var formLabelBundle = popup.querySelector('[data-offre-form-label-bundle]');
    if (formLabelBundle) formLabelBundle.textContent = d.popupTitle || '';

    // Inject fan images (top) — innerHTML rebuild retriggers CSS animations automatically
    var fanWrap = popup.querySelector('.offre-acc__fan-wrap');
    if (fanWrap && d.popupImages) fanWrap.innerHTML = buildFanHTML(d.popupImages, d.popupUrls || '');

    // Rebuild kit: title + tagline + checkmark list (no image reel here anymore)
    var kitEl = popup.querySelector('.offre-acc__kit');
    if (kitEl) {
      var kitInner = d.popupKitName ? '<p class="offre-acc__kit-name">' + d.popupKitName + '</p>' : '';
      if (d.popupKitTagline) kitInner += '<p class="offre-acc__kit-tagline">' + d.popupKitTagline + '</p>';
      if (d.popupKitItems)   kitInner += buildKitListHTML(d.popupKitItems);
      kitEl.innerHTML = kitInner;
    }

    // Populate products strip (outside kit card)
    var productsStrip  = popup.querySelector('[data-offre-products-strip]');
    var productsReel   = popup.querySelector('[data-offre-products-reel]');
    var reelWrap       = popup.querySelector('[data-offre-products-reel-wrap]');
    var totalPriceEl   = popup.querySelector('[data-offre-total-price]');
    var bundleAtcBtn   = popup.querySelector('[data-offre-bundle-atc]');
    if (productsStrip) {
      if (d.popupImages) {
        if (productsReel) {
          productsReel.innerHTML = buildProductsReelHTML(d.popupImages, d.popupPrices || '', d.popupUrls || '');
          // Fade right on reel
          if (reelWrap) {
            function updateReelFade() {
              var atEnd = productsReel.scrollLeft + productsReel.clientWidth >= productsReel.scrollWidth - 8;
              var hasMore = productsReel.scrollWidth > productsReel.clientWidth + 8;
              reelWrap.classList.toggle('offre-acc__products-reel-wrap--no-fade', atEnd || !hasMore);
            }
            productsReel.removeEventListener('scroll', productsReel._fadeListener);
            productsReel._fadeListener = updateReelFade;
            productsReel.addEventListener('scroll', updateReelFade, { passive: true });
            setTimeout(updateReelFade, 50);
          }
        }
        if (totalPriceEl && d.popupBundlePrice) {
          var crossedHTML = (d.popupProductsTotal && d.popupProductsTotal !== d.popupBundlePrice)
            ? '<span class="offre-acc__total-price-crossed">' + d.popupProductsTotal + '</span>'
            : '';
          totalPriceEl.innerHTML = crossedHTML + '<span class="offre-acc__total-price-main">' + d.popupBundlePrice + '</span>';
          totalPriceEl.hidden = false;
        }
        if (bundleAtcBtn && d.popupBundleVariant) {
          bundleAtcBtn.dataset.offreBundleVariant = d.popupBundleVariant;
          if (d.popupBtnText) bundleAtcBtn.textContent = d.popupBtnText;
          // Si claimable → formulaire email = CTA principal, on cache le bouton ATC
          bundleAtcBtn.hidden = !!d.popupClaimable;
        }
        // Ligne d'économies — uniquement si non claimable
        var savingsEl = popup.querySelector('[data-offre-savings]');
        if (savingsEl) {
          var rawTotal = parseInt(d.popupProductsTotalRaw, 10);
          var rawBundle = parseInt(d.popupBundlePriceRaw, 10);
          if (!d.popupClaimable && !isNaN(rawTotal) && !isNaN(rawBundle) && rawTotal > rawBundle) {
            var savedCents = rawTotal - rawBundle;
            var savedEur = Math.ceil(savedCents / 100);
            savingsEl.textContent = '\ud83d\udd25 \u00c9conomisez ' + savedEur + '\u00a0\u20ac en ajoutant ce pack maintenant';
            savingsEl.hidden = false;
          } else {
            savingsEl.hidden = true;
          }
        }
        // Bouton "Continuer sans pack" — visible si ouvert depuis l'ATC principal
        var skipBtn = popup.querySelector('[data-offre-skip]');
        if (skipBtn) skipBtn.hidden = !fromAtc;
        productsStrip.hidden = false;
      } else {
        productsStrip.hidden = true;
      }
    }

    // Si pas claimable : cacher formulaire email + label row
    var claimable  = !!d.popupClaimable;
    var formEl          = popup.querySelector('.offre-acc__form');
    var formLabelRow    = popup.querySelector('.offre-acc__form-label-row');
    var hide = claimable ? '' : 'none';
    if (formEl)         formEl.style.display         = hide;
    if (formLabelRow)   formLabelRow.style.display   = hide;

    // Activate bundle mode (open first — order matters for MutationObserver)
    popup.classList.add('offre-acc--open', 'offre-acc--bundle-mode');
    if (d.bcBtnBg) popup.classList.add('offre-acc--bundle-btn');
    // Store hidden ATC button from the source card for use on claimable form submit
    var hiddenAtcBtn = btn.parentElement ? btn.parentElement.querySelector('[data-offre-hidden-atc]') : null;
    popup._offreHiddenAtcBtn = hiddenAtcBtn || null;
    // Store the non-claimable card ATC button for "Choisir cette configuration"
    var cardFooter = btn.closest('.bundle-card__footer');
    var cardAtcBtn = cardFooter ? cardFooter.querySelector('[ref="addToCartButton"]:not([data-offre-hidden-atc])') : null;
    popup._offreCardAtcBtn = cardAtcBtn || null;
  });

  // Restore everything when popup closes
  (function () {
    var popup = document.getElementById('offre-acc-root');
    if (!popup) return;
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.attributeName !== 'class') return;
        var wasOpen = m.oldValue ? m.oldValue.indexOf('offre-acc--open') !== -1 : false;
        var isNowClosed = !popup.classList.contains('offre-acc--open');
        if (wasOpen && isNowClosed && originals) {
          // Restore colors
          popup.style.removeProperty('--acc-green');
          popup.style.removeProperty('--acc-light');
          popup.style.removeProperty('--acc-border');
          popup.style.removeProperty('--acc-btn-bg');
          popup.style.removeProperty('--acc-accent');
          popup.style.removeProperty('--acc-btn-color');
          popup.classList.remove('offre-acc--bundle-btn', 'offre-acc--bundle-mode');
          // Clear fan
          var fanWrap = popup.querySelector('.offre-acc__fan-wrap');
          if (fanWrap) fanWrap.innerHTML = '';
          // Restore kit
          setHTML(popup, '.offre-acc__kit', originals.kitHTML);
          // Restore text
          setText(popup, '.offre-acc__badge',      originals.badge);
          setText(popup, '.offre-acc__title',      originals.title);
          setText(popup, '.offre-acc__desc',       originals.desc);
          setText(popup, '.offre-acc__submit',     originals.submit);
          setText(popup, '[data-offre-code]',      originals.code);
          // Clear bundle name next to form label
          var formLabelBundle = popup.querySelector('[data-offre-form-label-bundle]');
          if (formLabelBundle) formLabelBundle.textContent = '';
          // Restore form/label visibility
          var formEl       = popup.querySelector('.offre-acc__form');
          var formLabelRow = popup.querySelector('.offre-acc__form-label-row');
          if (formEl)       formEl.style.display       = '';
          if (formLabelRow) formLabelRow.style.display = '';
          // Hide products strip
          var productsStrip = popup.querySelector('[data-offre-products-strip]');
          var productsReel  = popup.querySelector('[data-offre-products-reel]');
          var totalPriceEl  = popup.querySelector('[data-offre-total-price]');
          var bundleAtcBtn  = popup.querySelector('[data-offre-bundle-atc]');
          if (productsStrip) productsStrip.hidden = true;
          if (productsReel) productsReel.innerHTML = '';
          if (totalPriceEl) { totalPriceEl.hidden = true; totalPriceEl.innerHTML = ''; }
          if (bundleAtcBtn) { bundleAtcBtn.hidden = true; delete bundleAtcBtn.dataset.offreBundleVariant; }
          var savingsEl = popup.querySelector('[data-offre-savings]');
          if (savingsEl) { savingsEl.hidden = true; savingsEl.textContent = ''; }
          var skipBtn = popup.querySelector('[data-offre-skip]');
          if (skipBtn) skipBtn.hidden = true;
          popup._offreHiddenAtcBtn = null;
          popup._offreCardAtcBtn = null;
        }
      });
    }).observe(popup, { attributes: true, attributeOldValue: true });
  })();

  // Bouton "Continuer sans pack" — ferme simplement le popup
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-offre-skip]');
    if (!btn) return;
    var popup = document.getElementById('offre-acc-root');
    if (popup) {
      popup.classList.remove('offre-acc--open');
      popup.setAttribute('aria-hidden', 'true');
    }
  });

  // ATC depuis le popup offre (bouton « Choisir cette configuration »)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-offre-bundle-atc]');
    if (!btn) return;
    var popup = document.getElementById('offre-acc-root');
    var cardAtcBtn = popup && popup._offreCardAtcBtn ? popup._offreCardAtcBtn : null;

    // Fermer le popup
    if (popup) {
      popup.classList.remove('offre-acc--open');
      popup.setAttribute('aria-hidden', 'true');
    }

    if (cardAtcBtn) {
      // Utilise le product-form-component de la carte → animation fly-to-cart + cart:update natifs
      cardAtcBtn.click();
    } else {
      // Fallback: fetch direct si pas de bouton source trouvé
      var variantId = btn.dataset.offreBundleVariant;
      if (!variantId) return;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
      })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw d; });
        return fetch('/cart.js').then(function (r2) { return r2.json(); });
      })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, data: { source: 'offre-bundle-atc' } }
        }));
      })
      .catch(function (err) { console.error('[offre] bundle ATC error', err); });
    }
  });})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calculateur-dimensionnement"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-calc-dim]').forEach(function (root) {
    var wrap = root.closest('.calc-dim');
    if (!wrap || wrap.dataset.calcDimInit) return;
    wrap.dataset.calcDimInit = 'true';

    var adultsInput = root.querySelector('[data-calc-dim-adults]');
    var decBtn = root.querySelector('[data-calc-dim-decrement]');
    var incBtn = root.querySelector('[data-calc-dim-increment]');
    var levelBtns = Array.prototype.slice.call(root.querySelectorAll('[data-calc-dim-level]'));
    var m2Out = root.querySelector('[data-calc-dim-m2]');
    var tierResult = root.querySelector('[data-calc-dim-tier-result]');
    var tierImg = root.querySelector('[data-calc-dim-tier-img]');
    var tierLabel = root.querySelector('[data-calc-dim-tier-label]');
    var tierName = root.querySelector('[data-calc-dim-tier-name]');
    var tierDesc = root.querySelector('[data-calc-dim-tier-desc]');
    var tierLink = root.querySelector('[data-calc-dim-tier-link]');

    var tiers = Array.prototype.slice.call(wrap.querySelectorAll('.calc-dim__tier-datum')).map(function (el) {
      return {
        min: parseFloat(el.dataset.min) || 0,
        max: parseFloat(el.dataset.max) || Infinity,
        label: el.dataset.label || '',
        name: el.dataset.name || '',
        desc: el.dataset.desc || '',
        url: el.dataset.url || '',
        img: el.dataset.img || ''
      };
    }).sort(function (a, b) { return a.min - b.min; });

    var currentLevel = levelBtns.length ? parseFloat(levelBtns[0].dataset.calcDimLevel) : 4;

    function pickTier(m2) {
      if (!tiers.length) return null;
      for (var i = 0; i < tiers.length; i++) {
        if (m2 <= tiers[i].max) return tiers[i];
      }
      return tiers[tiers.length - 1];
    }

    function render() {
      var adults = Math.max(1, parseInt(adultsInput.value, 10) || 1);
      var m2 = Math.round(adults * currentLevel);
      if (m2Out) m2Out.textContent = m2;

      var tier = pickTier(m2);
      if (!tier || !tierResult) return;

      tierResult.hidden = false;
      if (tierLabel) tierLabel.textContent = tier.label;
      if (tierName) tierName.textContent = tier.name;
      if (tierDesc) tierDesc.textContent = tier.desc;
      if (tierLink && tier.url) tierLink.setAttribute('href', tier.url);
      if (tierImg) {
        tierImg.style.backgroundImage = tier.img ? 'url(' + tier.img + ')' : 'none';
      }
    }

    if (decBtn) {
      decBtn.addEventListener('click', function () {
        adultsInput.value = Math.max(1, (parseInt(adultsInput.value, 10) || 1) - 1);
        render();
      });
    }
    if (incBtn) {
      incBtn.addEventListener('click', function () {
        adultsInput.value = Math.min(8, (parseInt(adultsInput.value, 10) || 1) + 1);
        render();
      });
    }
    if (adultsInput) adultsInput.addEventListener('input', render);

    levelBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        levelBtns.forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');
        currentLevel = parseFloat(btn.dataset.calcDimLevel);
        render();
      });
    });

    render();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calendrier-culture"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-calendrier-culture]').forEach(function (root) {
    if (root.dataset.calendrierCultureInit) return;
    root.dataset.calendrierCultureInit = 'true';

    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-calendrier-culture-target]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-calendrier-culture-panel]'));

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.dataset.calendrierCultureTarget;

        buttons.forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          p.classList.toggle('is-active', p.dataset.calendrierCulturePanel === target);
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["configurateur-inline"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('.cfg-inline');
    if (!section) return;

    function _optimisticIncrement() {
      var countEl = document.querySelector('[ref="cartBubbleCount"]');
      var bubbleEl = document.querySelector('[ref="cartBubble"]');
      var cartIconEl = document.querySelector('cart-icon');
      if (!countEl || !bubbleEl) return;
      var next = (parseInt(countEl.textContent || '0', 10) || 0) + 1;
      countEl.textContent = String(next);
      countEl.classList.remove('hidden');
      bubbleEl.classList.remove('visually-hidden');
      if (cartIconEl) cartIconEl.classList.add('header-actions__cart-icon--has-cart');
    }

    function _rollbackCount() {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var cartIconEl = document.querySelector('cart-icon');
          if (cartIconEl && typeof cartIconEl.renderCartBubble === 'function') {
            cartIconEl.renderCartBubble(cart.item_count || 0, false, false);
          }
        })
        .catch(function () {});
    }

    // Pack 1 — afficher panneau email (+ ATC pack offert si variant dispo)
    section.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cfg-inline-open-email]');
      if (!btn) return;
      var panel = document.getElementById('cfg-inline-email-panel');
      var grid = section.querySelector('.cfg-inline__grid');
      function openPanel() {
        if (panel) panel.hidden = false;
        if (grid) grid.hidden = true;
      }
      var freeVariantId = btn.dataset.cfgInlineFreeAtc;
      if (freeVariantId) {
        _optimisticIncrement();
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(freeVariantId, 10), quantity: 1 })
        }).then(function (r) {
          if (!r.ok) _rollbackCount();
          openPanel();
        }).catch(function () {
          _rollbackCount();
          openPanel();
        });
      } else {
        openPanel();
      }
    });

    // Pack 1 — fermer panneau email
    section.addEventListener('click', function (e) {
      if (!e.target.closest('[data-cfg-inline-close-email]')) return;
      var panel = document.getElementById('cfg-inline-email-panel');
      var grid = section.querySelector('.cfg-inline__grid');
      if (panel) panel.hidden = true;
      if (grid) grid.hidden = false;
    });

    // Pack 2/3 — ATC + ouvrir panier
    section.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cfg-inline-atc]');
      if (!btn) return;
      var variantId = btn.dataset.cfgInlineAtc;
      if (!variantId) return;
      _optimisticIncrement();
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
      }).then(function (r) {
        if (!r.ok) { _rollbackCount(); return; }
        return r.json().then(function () {
          return fetch('/cart.js').then(function (r2) { return r2.json(); });
        }).then(function (cart) {
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              data: { source: 'cfg-inline', itemCount: cart.item_count }
            }
          }));
        });
      }).catch(function () {
        _rollbackCount();
      });
    });

    // Formulaire email (Pack 1)
    section.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-cfg-inline-email-form]');
      if (!form) return;
      e.preventDefault();
      var emailInput = form.querySelector('input[type="email"]');
      var email = emailInput ? emailInput.value.trim() : '';
      var errorEl = form.querySelector('[data-cfg-inline-email-error]');
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        if (errorEl) errorEl.hidden = false;
        if (emailInput) emailInput.focus();
        return;
      }
      if (errorEl) errorEl.hidden = true;
      var submitBtn = form.querySelector('.cfg-inline__email-submit');
      if (submitBtn) submitBtn.disabled = true;

      var body = new URLSearchParams();
      body.set('form_type', 'customer');
      body.set('utf8', '\u2713');
      body.set('contact[email]', email);
      body.set('contact[tags]', 'newsletter,pack-offert-serre');

      fetch('/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' },
        body: body.toString()
      }).catch(function () {}).finally(function () {
        form.hidden = true;
        var success = document.getElementById('cfg-inline-email-success');
        if (success) success.hidden = false;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cta-configurateur"] && !Shopify.designMode) return;
  try {
    
  // Scroll vers le configurateur
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-scroll-to-quiz]')) return;
    e.preventDefault();
    var target = document.querySelector('[data-quiz]');
    if (!target) return;
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var section = document.querySelector('.faq');
    if (!section) return;
    var header = section.querySelector('.faq__header');

    var items    = Array.from(section.querySelectorAll('[data-faq-item]'));
    var groups   = Array.from(section.querySelectorAll('[data-faq-group]'));
    var filters  = Array.from(section.querySelectorAll('[data-faq-filter]'));
    var searchEl = section.querySelector('[data-faq-search]');
    var noRes    = section.querySelector('[data-faq-no-results]');
    var chips    = Array.from(section.querySelectorAll('[data-faq-jump]'));

    // Premier filtre actif = première catégorie
    var activeCat = filters.length ? filters[0].dataset.faqFilter : 'utilisation';

    // Init : afficher seulement la première catégorie et synchroniser le bouton actif
    setFilter(activeCat);

    // Accordion : close others
    section.addEventListener('click', function (e) {
      var summary = e.target.closest('summary.faq__question');
      if (!summary) return;
      var clicked = summary.closest('details.faq__item');
      if (!clicked) return;
      items.forEach(function (it) { if (it !== clicked && it.open) it.open = false; });
    });

    // Popular chips → jump & open
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var id = chip.dataset.faqJump;
        var target = document.getElementById('faq-' + id);
        if (!target) return;
        var chipCat = target.dataset.faqCat;
        setFilter(chipCat);
        target.open = true;
        setTimeout(function () { target.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 80);
      });
    });

    // Category filters
    filters.forEach(function (btn) {
      btn.addEventListener('click', function () { setFilter(btn.dataset.faqFilter); });
    });

    function setFilter(cat) {
      activeCat = cat;
      filters.forEach(function (b) { b.classList.toggle('faq__filter--active', b.dataset.faqFilter === cat); });
      applyFilter(searchEl ? searchEl.value.trim().toLowerCase() : '');
      if (window.innerWidth < 990) {
        var rightCol = section.querySelector('.faq__col-right');
        if (rightCol) setTimeout(function () { rightCol.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 60);
      }
    }

    // Search
    if (searchEl) {
      searchEl.addEventListener('input', function () {
        applyFilter(searchEl.value.trim().toLowerCase());
      });
    }

    function applyFilter(query) {
      var visible = 0;
      items.forEach(function (item) {
        var cat  = item.dataset.faqCat;
        var text = item.textContent.toLowerCase();
        var catOk  = activeCat === 'all' || cat === activeCat;
        var textOk = !query || text.includes(query);
        var show = catOk && textOk;
        item.hidden = !show;
        if (show) visible++;
      });
      // Show/hide groups depending on if they have visible items
      groups.forEach(function (g) {
        var hasVisible = Array.from(g.querySelectorAll('[data-faq-item]')).some(function (i) { return !i.hidden; });
        g.hidden = !hasVisible;
      });
      // Hide popular chips + group titles when searching
      var pop = section.querySelector('[data-faq-popular]');
      if (pop) pop.hidden = !!query;
      if (noRes) noRes.hidden = visible > 0;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["guide-choix"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-offre-guide-open]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var cb = document.querySelector('[data-bundle-open-offre][data-popup-claimable="true"]');
      if (cb) { cb.click(); return; }
      // Fallback : ouvrir le popup sans bundle
      var s = document.getElementById('offre-acc-root');
      if (s) {
        s.classList.add('offre-acc--open');
        s.removeAttribute('aria-hidden');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-policy"]) return;
  try {
    
  document.querySelectorAll('[data-policy-content]').forEach((content) => {
    const pageTitle = content.closest('.main-policy')?.querySelector('.main-policy__title')?.textContent?.trim();
    if (!pageTitle) return;

    const firstHeading = content.querySelector('h1, h2, h3');
    if (!firstHeading) return;

    const headingText = firstHeading.textContent?.trim();
    if (!headingText) return;

    if (headingText === pageTitle || headingText.includes(pageTitle) || pageTitle.includes(headingText)) {
      firstHeading.remove();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offre"] && !Shopify.designMode) return;
  try {
    
  /* noop — popup logic is in plugin.js */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-features"] && !Shopify.designMode) return;
  try {
    
// section desactivee - cartes affichees via CSS dans la description produit

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quiz-recommender"] && !Shopify.designMode) return;
  try {
    
  (function () {
  function initQuiz(quiz) {
    var scores = {};
    var step = 1;
    var TOTAL = 3;

    function setProgress(pct, label) {
      var fill = quiz.querySelector('.quiz__progressbar-fill');
      var counter = quiz.querySelector('.quiz__counter');
      if (fill) fill.style.setProperty('--pct', pct + '%');
      if (counter) counter.textContent = label;
    }

    function showStep(target) {
      quiz.querySelectorAll('.quiz__step').forEach(function (el) {
        el.classList.remove('is-active');
      });
      var el =
        target === 'result'
          ? quiz.querySelector('[data-step="result"]')
          : quiz.querySelector('[data-step="' + target + '"]');
      if (el) el.classList.add('is-active');
    }

    function showResult() {
      var winner = null;
      var max = 0;
      Object.keys(scores).forEach(function (k) {
        if (scores[k] > max) {
          max = scores[k];
          winner = k;
        }
      });
      quiz.querySelectorAll('[data-result]').forEach(function (card) {
        if (card.dataset.result === winner) {
          card.classList.remove('quiz__result-card--hidden');
        } else {
          card.classList.add('quiz__result-card--hidden');
        }
      });
      setProgress(100, '');
      showStep('result');
    }

    quiz.addEventListener('click', function (e) {
      var opt = e.target.closest('.quiz__option');
      var restart = e.target.closest('.quiz__restart');

      if (opt) {
        var p = opt.dataset.profile;
        scores[p] = (scores[p] || 0) + 1;
        if (step < TOTAL) {
          step++;
          setProgress(Math.round(((step - 1) / TOTAL) * 100), step + ' / ' + TOTAL);
          showStep(step);
        } else {
          showResult();
        }
      }

      if (restart) {
        scores = {};
        step = 1;
        setProgress(0, '1 / ' + TOTAL);
        showStep(1);
      }
    });

    // Init
    setProgress(0, '1 / ' + TOTAL);
    showStep(1);
  }

  function initAllQuizzes() {
    document.querySelectorAll('[data-quiz]').forEach(initQuiz);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllQuizzes);
  } else {
    initAllQuizzes();
  }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smart-upsell"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBundles() {
      if (window.innerWidth > 749) return;
      var grids = document.querySelectorAll('.su-bundles__grid');
      grids.forEach(function (grid) {
        var dotsWrap = grid.parentElement.querySelector('.su-bundles__dots');
        var dots = dotsWrap ? dotsWrap.querySelectorAll('.su-bundles__dot') : [];
        var bundles = Array.from(grid.querySelectorAll('.su-bundle'));

        function activeDotIdx() {
          var midX = grid.scrollLeft + grid.clientWidth / 2;
          var closest = 1;
          var closestDist = Infinity;
          bundles.forEach(function (b, i) {
            var dist = Math.abs((b.offsetLeft + b.clientWidth / 2) - midX);
            if (dist < closestDist) { closestDist = dist; closest = i; }
          });
          return closest;
        }

        function updateDots(idx) {
          dots.forEach(function (d, i) { d.classList.toggle('su-bundles__dot--active', i === idx); });
        }

        // Scroll to popular (middle)
        var popular = grid.querySelector('.su-bundle--popular');
        if (popular) {
          var offset = popular.offsetLeft - (grid.offsetWidth - popular.offsetWidth) / 2;
          grid.scrollLeft = offset;
        }
        updateDots(activeDotIdx());

        var scrollTimer;
        grid.addEventListener('scroll', function () {
          clearTimeout(scrollTimer);
          scrollTimer = setTimeout(function () { updateDots(activeDotIdx()); }, 60);
        }, { passive: true });

        // Dot click → scroll to that bundle
        dots.forEach(function (d, i) {
          d.style.cursor = 'pointer';
          d.addEventListener('click', function () {
            if (!bundles[i]) return;
            var left = bundles[i].offsetLeft - (grid.clientWidth - bundles[i].clientWidth) / 2;
            grid.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
          });
        });
      });
    }

    function _optimisticIncrement() {
      var countEl = document.querySelector('[ref="cartBubbleCount"]');
      var bubbleEl = document.querySelector('[ref="cartBubble"]');
      var cartIconEl = document.querySelector('cart-icon');
      if (!countEl || !bubbleEl) return;
      var next = (parseInt(countEl.textContent || '0', 10) || 0) + 1;
      countEl.textContent = String(next);
      countEl.classList.remove('hidden');
      bubbleEl.classList.remove('visually-hidden');
      if (cartIconEl) cartIconEl.classList.add('header-actions__cart-icon--has-cart');
    }

    function _rollbackCount() {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var cartIconEl = document.querySelector('cart-icon');
          if (cartIconEl && typeof cartIconEl.renderCartBubble === 'function') {
            cartIconEl.renderCartBubble(cart.item_count || 0, false, false);
          }
        })
        .catch(function () {});
    }

    function openOffre() {
      if (window._psOpenOffre) { window._psOpenOffre(); return; }
      var popup = document.getElementById('offre-acc-root');
      if (popup) { popup.classList.add('offre-acc--open'); popup.removeAttribute('aria-hidden'); }
    }

    // ── Click handlers for bundle CTA buttons ──────────────────────────
    function addVariantToCart(variantId, btn) {
      btn.disabled = true;
      _optimisticIncrement();

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          btn.disabled = false;
          if (data.status) {
            // Error — rollback the optimistic count
            _rollbackCount();
            return;
          }
          // Sync real cart count via cart-icon component
          var cartIconEl = document.querySelector('cart-icon');
          if (cartIconEl && typeof cartIconEl.renderCartBubble === 'function') {
            fetch('/cart.js')
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                cartIconEl.renderCartBubble(cart.item_count || 0, true, true);
              })
              .catch(function () {});
          }
          // Open cart drawer if available
          document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
        })
        .catch(function () {
          btn.disabled = false;
          _rollbackCount();
        });
    }

    document.addEventListener('click', function (e) {
      // Bundle 2 + 3: data-su-atc → add to cart
      var atcBtn = e.target && e.target.closest && e.target.closest('[data-su-atc]');
      if (atcBtn) {
        var variantId = atcBtn.dataset.suVariant;
        if (!variantId) return;
        e.preventDefault();
        addVariantToCart(parseInt(variantId, 10), atcBtn);
        return;
      }

      // Bundle 1: data-su-free-atc → open offre popup
      var freeBtn = e.target && e.target.closest && e.target.closest('[data-su-free-atc]');
      if (freeBtn) {
        e.preventDefault();
        openOffre();
      }
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initBundles);
    } else {
      initBundles();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zone-climatique"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-zone-clim]').forEach(function (root) {
    if (root.dataset.zoneClimInit) return;
    root.dataset.zoneClimInit = 'true';

    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-zone-clim-target]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-zone-clim-panel]'));

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.dataset.zoneClimTarget;

        buttons.forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          p.classList.toggle('is-active', p.dataset.zoneClimPanel === target);
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
